import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import IconInfoCircle from '../icons/IconInfoCircle.vue';
import IconWarningCircle from '../icons/IconWarningCircle.vue';
import IconSuccessCircle from '../icons/IconSuccessCircle.vue';
import IconDangerCircle from '../icons/IconDangerCircle.vue';
import Button from './Button.vue';

// Props with default values

export default /*@__PURE__*/_defineComponent({
  __name: 'Message',
  props: {
    message: {},
    type: { default: 'info' },
    showIcon: { type: Boolean, default: true },
    size: { default: 'normal' },
    link: {}
  },
  setup(__props: any) {



// Get styles for type
const typeStyles = {
    info: ['bg-info-50', 'text-info-900', 'border-info-100'],
    warning: ['bg-warning-50', 'text-warning-900', 'border-warning-100'],
    success: ['bg-success-50', 'text-success-500', 'border-success-100'],
    danger: ['bg-danger-50', 'text-danger-500', 'border-danger-100'],
    neutral: ['bg-neutral-50', 'text-base-500', 'border-neutral-100'],
};

const styles = computed(() => typeStyles[__props.type].join(' '));

// Map to eagerly loaded components
const iconMap = {
    info: IconInfoCircle,
    warning: IconWarningCircle,
    success: IconSuccessCircle,
    danger: IconDangerCircle,
};

const iconComponent = computed(() => iconMap[__props.type]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            'inline-flex items-center border',
            _ctx.showIcon && 'gap-2',
            _ctx.size === 'normal' && 'px-2.5 py-0.5 text-xs leading-xs rounded',
            _ctx.size === 'large' && 'px-4 py-2 text-base leading-base rounded-lg',
            _ctx.message === '' && 'hidden',
            styles.value,
        ])
  }, [
    (_ctx.showIcon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(iconComponent.value)))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass([_ctx.size === 'large' && 'flex-1 text-left'])
    }, _toDisplayString(_ctx.message), 3),
    (_ctx.link)
      ? (_openBlock(), _createBlock(Button, {
          key: 1,
          href: _ctx.link.url,
          text: _ctx.link.label,
          type: "secondary",
          size: "small"
        }, null, 8, ["href", "text"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})